// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.coupon-code-card-wrapper {
  width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  border: 1px solid #ddd;
  border-radius: 6px;
}
.coupon-code-card-wrapper .coupon-code-card-text {
  font-size: 18px;
  font-weight: 700;
  color: #000;
}
.coupon-code-card-wrapper .coupon-code-card-input-wrapper {
  display: flex;
  gap: 12px;
}
.coupon-code-card-wrapper .coupon-code-card-input-wrapper > div {
  width: 100%;
  position: relative;
}
.coupon-code-card-wrapper .coupon-code-card-input-wrapper > div input {
  background: #F1F1F1;
  border-radius: 4px;
  padding: 10px 12px;
  padding-right: 35px;
  width: 100%;
  min-width: 180px;
  font-size: 14px;
  font-weight: 600;
  color: #494949;
}
.coupon-code-card-wrapper .coupon-code-card-input-wrapper > div input:focus-visible {
  outline: 1px solid #93288E;
}
.coupon-code-card-wrapper .coupon-code-card-input-wrapper > div button {
  position: absolute;
  right: 10px;
  top: 25%;
  cursor: pointer;
}
.coupon-code-card-wrapper .coupon-code-card-input-wrapper > button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 16px;
  background: #93288E;
  color: #fff;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 700;
  width: 100%;
  max-width: 150px;
}
.coupon-code-card-wrapper .coupon-code-card-input-wrapper > button.green-bg {
  background: #00AA44;
}
.coupon-code-card-wrapper .coupon-code-card-desc-text {
  font-size: 12px;
  margin-top: -12px;
  color: #00AA44;
}
.coupon-code-card-wrapper .coupon-code-card-coupons-wrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: #F6F9FF;
}
.coupon-code-card-wrapper .coupon-code-card-coupons-wrapper.add-padding {
  padding: 16px;
  padding-bottom: 0;
}
.coupon-code-card-wrapper .coupon-code-card-coupons-wrapper .bank-offers-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.coupon-code-card-wrapper .coupon-code-card-coupons-wrapper .bank-offers-wrapper .bank-offer {
  display: flex;
  justify-content: space-between;
  padding: 8px 16px;
  padding-top: 6px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
}
.coupon-code-card-wrapper .coupon-code-card-coupons-wrapper .bank-offers-wrapper .bank-offer div {
  display: flex;
  align-items: end;
  gap: 8px;
}
.coupon-code-card-wrapper .coupon-code-card-coupons-wrapper .bank-offers-wrapper .bank-offer div .bank-name {
  font-size: 14px;
  font-weight: 600;
  color: #000;
}
.coupon-code-card-wrapper .coupon-code-card-coupons-wrapper .bank-offers-wrapper .bank-offer div .terms-conditions {
  font-size: 10px;
  font-weight: 600;
  color: #656565;
  text-decoration: underline;
  cursor: pointer;
}
.coupon-code-card-wrapper .coupon-code-card-coupons-wrapper .bank-offers-wrapper .bank-offer .apply-button {
  font-size: 15px;
  font-weight: 700;
  color: #00AA44;
  cursor: pointer;
}
.coupon-code-card-wrapper .coupon-code-card-coupons-wrapper .view-button-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 14px;
  background-color: #F6F9FF;
  height: 50px;
}
.coupon-code-card-wrapper .coupon-code-card-coupons-wrapper .view-button-wrapper div {
  display: flex;
  gap: 8px;
  cursor: pointer;
}
.coupon-code-card-wrapper .coupon-code-card-coupons-wrapper .view-button-wrapper div span {
  font-size: 16px;
  font-weight: 500;
  color: #008CFF;
}
.coupon-code-card-wrapper .coupon-code-card-coupons-wrapper .view-button-wrapper div .open {
  transform: rotate(90deg);
}
.coupon-code-card-wrapper .coupon-code-card-coupons-wrapper .view-button-wrapper div .close {
  margin-left: 12px;
  transform: rotate(-90deg);
}

@media only screen and (width <= 425px) {
  .coupon-code-card-wrapper .coupon-code-card-input-wrapper {
    flex-wrap: wrap;
  }
  .coupon-code-card-wrapper .coupon-code-card-input-wrapper input {
    min-width: 180px;
  }
  .coupon-code-card-wrapper .coupon-code-card-input-wrapper button {
    max-width: 100%;
  }
  .coupon-code-card-wrapper .coupon-code-card-desc-text {
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/PublicPaymentPage/components/CouponCodeCard/style.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,sBAAA;EACA,kBAAA;AACJ;AACI;EACI,eAAA;EACA,gBAAA;EACA,WAAA;AACR;AAEI;EACI,aAAA;EACA,SAAA;AAAR;AAEQ;EACI,WAAA;EACA,kBAAA;AAAZ;AAEY;EACI,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAAhB;AAEgB;EACI,0BAAA;AAApB;AAIY;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,eAAA;AAFhB;AAMQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AAJZ;AAMY;EACI,mBAAA;AAJhB;AASI;EACI,eAAA;EACA,iBAAA;EACA,cAAA;AAPR;AAUI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AARR;AAUQ;EACI,aAAA;EACA,iBAAA;AARZ;AAWQ;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AATZ;AAWY;EACI,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;AAThB;AAWgB;EACI,aAAA;EACA,gBAAA;EACA,QAAA;AATpB;AAWoB;EACI,eAAA;EACA,gBAAA;EACA,WAAA;AATxB;AAYoB;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;EACA,eAAA;AAVxB;AAcgB;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAZpB;AAiBQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,YAAA;AAfZ;AAiBY;EACI,aAAA;EACA,QAAA;EACA,eAAA;AAfhB;AAiBgB;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAfpB;AAkBgB;EACI,wBAAA;AAhBpB;AAmBgB;EACI,iBAAA;EACA,yBAAA;AAjBpB;;AA0BA;EAEQ;IACI,eAAA;EAxBV;EA0BU;IACI,gBAAA;EAxBd;EA2BU;IACI,eAAA;EAzBd;EA6BM;IACI,kBAAA;EA3BV;AACF","sourcesContent":[".coupon-code-card-wrapper {\n    width: 100%;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n\n    .coupon-code-card-text {\n        font-size: 18px;\n        font-weight: 700;\n        color: #000;\n    }\n\n    .coupon-code-card-input-wrapper {\n        display: flex;\n        gap: 12px;\n\n        >div {\n            width: 100%;\n            position: relative;\n\n            input {\n                background: #F1F1F1;\n                border-radius: 4px;\n                padding: 10px 12px;\n                padding-right: 35px;\n                width: 100%;\n                min-width: 180px;\n                font-size: 14px;\n                font-weight: 600;\n                color: #494949;\n\n                &:focus-visible {\n                    outline: 1px solid #93288E;\n                }\n            }\n\n            button {\n                position: absolute;\n                right: 10px;\n                top: 25%;\n                cursor: pointer;\n            }\n        }\n\n        >button {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            gap: 8px;\n            padding: 8px 16px;\n            background: #93288E;\n            color: #fff;\n            border-radius: 4px;\n            font-size: 14px;\n            font-weight: 700;\n            width: 100%;\n            max-width: 150px;\n\n            &.green-bg {\n                background: #00AA44;\n            }\n        }\n    }\n\n    .coupon-code-card-desc-text{\n        font-size: 12px;\n        margin-top: -12px;\n        color: #00AA44;\n    }\n\n    .coupon-code-card-coupons-wrapper {\n        display: flex;\n        flex-direction: column;\n        gap: 4px;\n        background: #F6F9FF;\n\n        &.add-padding {\n            padding: 16px;\n            padding-bottom: 0;\n        }\n\n        .bank-offers-wrapper {\n            display: flex;\n            flex-direction: column;\n            gap: 16px;\n\n            .bank-offer {\n                display: flex;\n                justify-content: space-between;\n                padding: 8px 16px;\n                padding-top: 6px;\n                background: #fff;\n                border: 1px solid #ddd;\n                border-radius: 4px;\n\n                div {\n                    display: flex;\n                    align-items: end;\n                    gap: 8px;\n\n                    .bank-name {\n                        font-size: 14px;\n                        font-weight: 600;\n                        color: #000;\n                    }\n\n                    .terms-conditions {\n                        font-size: 10px;\n                        font-weight: 600;\n                        color: #656565;\n                        text-decoration: underline;\n                        cursor: pointer;\n                    }\n                }\n\n                .apply-button {\n                    font-size: 15px;\n                    font-weight: 700;\n                    color: #00AA44;\n                    cursor: pointer;\n                }\n            }\n        }\n\n        .view-button-wrapper {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            gap: 14px;\n            background-color: #F6F9FF;\n            height: 50px;\n\n            div {\n                display: flex;\n                gap: 8px;\n                cursor: pointer;\n\n                span {\n                    font-size: 16px;\n                    font-weight: 500;\n                    color: #008CFF;\n                }\n\n                .open {\n                    transform: rotate(90deg);\n                }\n\n                .close {\n                    margin-left: 12px;\n                    transform: rotate(-90deg);\n                }\n            }\n\n        }\n\n    }\n}\n\n@media only screen and (width <=425px) {\n    .coupon-code-card-wrapper {\n        .coupon-code-card-input-wrapper {\n            flex-wrap: wrap;\n\n            input {\n                min-width: 180px;\n            }\n\n            button {\n                max-width: 100%;\n            }\n        }\n\n        .coupon-code-card-desc-text{\n            text-align: center;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
